<template>
  <div>
      <h3>Global</h3>
      <div>
        <compose />
      </div>
      <div>
        <list :data="data" type="Post" :option="option" ref="list" />
      </div>
  </div>
</template>

<script>
import Compose from '~/components/Compose'
import List from '~/components/List'
import api from '~/plugins/api'
import bus from '~/assets/js/bus'

export default {
  data() {
    return {
      hide_directed_posts: false,
    }
  },
  mounted() {
    bus.$on('post', this.add)
    this.hide_directed_posts = localStorage.getItem(`hide_directed_posts`)
    console.log('set', this.hide_directed_posts)
  },
  async asyncData(ctx) {
    // ctx.store.state.unified_timeline
    console.log('ctx.store.state', ctx.store.state)
    // no this, no localStorage..
    //console.log('this.hide_directed_posts', this.hide_directed_posts)
    //console.log('hide_directed_posts', localStorage.getItem(`hide_directed_posts`))
    const option = {
      include_directed_posts: ctx.store.state.hide_directed_posts ? 0 : 1
    }
    console.log('global', option)
    const data = await api(ctx).fetch(option)
    return { data, option }
  },
  components: {
    List,
    Compose
  },
  beforeDestroy() {
    bus.$off('post', this.add)
  },
  methods: {
    add(post) {
      this.$refs.list.refresh()
    }
  },
  head: {
    title: 'Global',
    meta: [
      {property: 'og:title', content: 'Beta, a Tavrn client | Global'},
      {property: 'og:type', content: 'article'},
      {property: 'og:url', content: 'https://beta.tavrn.gg/global'},
      {property: 'og:description', content: 'Global feed on Beta for Tavrn open world social network'},
      {property: 'og:image', content: 'https://beta.tavrn.gg/_nuxt/img/beta.6b17b7d.png'},
      {property: 'twitter:image:src', content: 'https://beta.tavrn.gg/_nuxt/img/beta.6b17b7d.png'},
      {property: 'og:image:width', content: '256'},
      {property: 'og:site_name', content: 'Tavrn | Beta | Global'}
    ]
  }
}
</script>



// WEBPACK FOOTER //
// global.vue?5303b16e